import { render, staticRenderFns } from "./AccountConfirmation.vue?vue&type=template&id=a3984c6a&scoped=true&"
import script from "./AccountConfirmation.vue?vue&type=script&lang=js&"
export * from "./AccountConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AccountConfirmation.vue?vue&type=style&index=0&id=a3984c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3984c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3984c6a')) {
      api.createRecord('a3984c6a', component.options)
    } else {
      api.reload('a3984c6a', component.options)
    }
    module.hot.accept("./AccountConfirmation.vue?vue&type=template&id=a3984c6a&scoped=true&", function () {
      api.rerender('a3984c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/checklist/AccountConfirmation.vue"
export default component.exports